import { render, staticRenderFns } from "./priceStrategyGroupAction.vue?vue&type=template&id=2350fa62"
import script from "./priceStrategyGroupAction.vue?vue&type=script&lang=js"
export * from "./priceStrategyGroupAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports